import { AxiosInstance } from "axios";
import { ResponseDto, ResponseLSDto } from "../../model/interface/common";
import { LoginByPasswordDto } from "@common/ict/model/interface/login";
import {
  CheckCodeDto,
  CheckCodeResponseDto,
  ResetPasswordDto,
  SendCodeDto
} from "@common/ict/model/interface/auth";

const baseLoginUrl = "api/IctFormAuthentication";

// 密码登录
export function loginByPasswordApi(
  request: AxiosInstance,
  data: LoginByPasswordDto
) {
  return request.post<ResponseDto, ResponseDto>(
    `${baseLoginUrl}/AppLogin`,
    data
  );
}

export function checkPhoneNumberApi(
  request: AxiosInstance,
  params: { phoneNumber: string }
) {
  return request.get<ResponseDto, ResponseDto>(
    `${baseLoginUrl}/CheckPhoenNumber`,
    {
      params
    }
  );
}

// 发送验证码
export function sendCodeApi(request: AxiosInstance, data: SendCodeDto) {
  return request.post<ResponseDto, ResponseDto>(
    `${baseLoginUrl}/SendYZMCode`,
    null,
    {
      params: data
    }
  );
}

// 验证验证码
export function checkCodeApi(request: AxiosInstance, data: CheckCodeDto) {
  return request.post<
    ResponseDto<CheckCodeResponseDto>,
    ResponseDto<CheckCodeResponseDto>
  >(`/zh-user/console/v1/user/reset/password`, null, {
    params: data
  });
}

// 重置密码
export function resetPasswordApi(
  request: AxiosInstance,
  data: ResetPasswordDto
) {
  return request.post<ResponseDto, ResponseDto>(
    `${baseLoginUrl}/ResetPassword`,
    data
  );
}

export function refreshTokenApi(request: AxiosInstance, refreshToken: string) {
  return request.post<ResponseLSDto, ResponseLSDto>(
    "zh-user/api/v1/token/refresh",
    {
      refreshToken
    }
  );
}

export function checkPhoneRegister(request: AxiosInstance, phone) {
  return Promise.resolve({ data: true, message: "成功", status: 4000200 });
  // return request.get<ResponseLSDto, ResponseLSDto>(
  //     `/zh-user/api/v1/user/query`,
  //     {
  //       params: {
  //         phone
  //       }
  //     }
  //   );
}
